// Pure helpers for the Course/Track Viewer session picker (ra-97jo).
//
// The picker browses recorded sessions (sail_no → device → session, via
// groupSessionsByBoat) and hands the chosen session up to the viewer, which
// fetches its track. These helpers keep the date defaults + per-session display
// shaping out of the React component so they can be unit-tested directly.

/** YYYY-MM-DD for `n` days before nowMs (UTC). */
export function isoDaysAgo(n, nowMs = Date.now()) {
  return new Date(nowMs - n * 86400000).toISOString().slice(0, 10);
}

/** Default browse window: the last 7 days (inclusive), as { fromDate, toDate }. */
export function defaultDateRange(nowMs = Date.now()) {
  return { fromDate: isoDaysAgo(6, nowMs), toDate: isoDaysAgo(0, nowMs) };
}

/**
 * Display fields for one session row in the picker. Times are rendered in UTC
 * (HH:MM) so the picker is deterministic regardless of the operator's locale.
 */
export function sessionRow(session) {
  const started = session?.startedAt ? new Date(session.startedAt) : null;
  const finished = session?.finishedAt ? new Date(session.finishedAt) : null;
  const startedOk = started && !Number.isNaN(started.getTime());
  const finishedOk = finished && !Number.isNaN(finished.getTime());
  return {
    sessionPath: session?.sessionPath || '',
    date: session?.date || (startedOk ? started.toISOString().slice(0, 10) : '—'),
    time: startedOk ? started.toISOString().slice(11, 16) : '—',
    courseName: session?.courseName || null,
    fleetClass: session?.fleetClass || '',
    status: session?.status || 'unknown',
    durationMin:
      startedOk && finishedOk ? Math.max(0, Math.round((finished - started) / 60000)) : null,
  };
}
